import axios from "axios";
import Instense from "./Axios-config";
import { API_ROOT } from "./Api-config";
 
export class LocationService {

public static GetLocationAll = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
   debugger;
  request.tenantid = tenantID;
  const url = `/Location/GetAll`;
  return Instense.get(url).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static GetUserLocationAll = async (request: any): Promise<any | null> => {
  const url = `/Location/GetUserLocation`;
  return Instense.get(url).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};



public static GetLocation = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  // const raw = localStorage.getItem("locationId");
  // const locationId = raw === null ? 0 : Number(raw) ;
  
  // request.LocationId = locationId;  
  request.tenantid = tenantID;
  const url = `/Location/GetLocation`;
  return Instense.get(url, { params: request }).then((response) => {
      let result = response.data.result as any;
      return result;
    });
};

public static UpdateLocation = async (request: any): Promise<any> => {
  // debugger;
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantid = storage === null ? 0 : (storage.tenantID as any);
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
  
  request.LocationId = request.locationId;
  request.TenantId = tenantid;
  const url = `/Location/UpdateLocation `;
  return Instense.post(url, request).then((response) => {
    // debugger;
      let result = response.data.result as any[];
      return result;
  });
};

public static SaveLogo = async (
  request: any, files: any[]
): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : storage.tenantID as any;
  request.TenantId = tenantID;
  // const raw = localStorage.getItem("locationId");
  // const locationId = raw === null ? 0 : Number(raw) ;
            
  // request.LocationId = locationId;
  const url = `/Location/SaveLogo`;
  const formData: FormData = new FormData();
  files.forEach(element => {
    formData.append('file', element);
  });

  formData.append('formField', JSON.stringify(request));
  return Instense.post(url, formData).then((response) => {
    let result = response.data.result as any;
    return result;
  });

};

public static GetLogo = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  // const raw = localStorage.getItem("locationId");
  // const locationId = raw === null ? 0 : Number(raw) ;
            
  // request.locationId = locationId;
  request.tenantid = tenantID;
  const url = `/Location/GetLogo`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static DownloadLogo = async (
  request: any,
  locationId: any
): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);

  request.TenantID = tenantID;
  request.locationId = locationId;

  const url = `/Location/DownloadLogo`;
  return Instense.post(url, request, { responseType: "blob" }).then(
    (response: any) => {

      let csvURL = window.URL.createObjectURL(response.data);
      let tempLink = document.createElement("a");
      tempLink.href = csvURL;
      tempLink.setAttribute("download", request.name);
      tempLink.click();
    }
  );
};

}